import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitobhopalcab() {



    const cardData = {





keyword: "Mumbai to Bhopal Cab",

headingDescription: "Shreesha Tours & Travels provides reliable and comfortable Mumbai to Bhopal Cab Service for business travel, family trips, corporate journeys, airport transfers, one-way cab booking, round trips, and long-distance road travel. We offer a wide range of chauffeur-driven vehicles including Sedan, SUV, Ertiga, Kia Carens, Innova, Innova Crysta, and premium cars to ensure a smooth and comfortable journey from Mumbai to Bhopal. Our experienced drivers, well-maintained fleet, transparent pricing, flexible booking options, doorstep pickup, and 24/7 customer support make every trip safe and hassle-free. Whether you are visiting Bhopal for business purposes, family visits, tourism, medical travel, or personal requirements, Shreesha Tours & Travels ensures a convenient and relaxing travel experience with professional cab services.",

topPlaces: [
  {
    title: "Upper Lake Bhopal",
    description: "Upper Lake, also known as Bhoj Tal, is one of Bhopal's most famous attractions, offering boating, beautiful views, and peaceful surroundings. It is a perfect place for families and tourists."
  },
  {
    title: "Van Vihar National Park Bhopal",
    description: "Van Vihar National Park is a popular wildlife destination located near Upper Lake, known for greenery, birds, animals, and nature experiences within the city."
  },
  {
    title: "Sanchi Stupa",
    description: "Sanchi Stupa is a UNESCO World Heritage Site near Bhopal, famous for ancient Buddhist monuments, historic architecture, and remarkable carvings."
  },
  {
    title: "Bhimbetka Rock Shelters",
    description: "Bhimbetka Rock Shelters are a UNESCO World Heritage Site known for prehistoric cave paintings and ancient human settlements. It is a major attraction for history and archaeology lovers."
  },
  {
    title: "Bhojpur Temple",
    description: "Bhojpur Temple is an ancient Shiva temple famous for its massive Shivling and impressive architecture. It is an important religious and historical destination near Bhopal."
  },
  {
    title: "Taj-ul-Masajid Bhopal",
    description: "Taj-ul-Masajid is one of India's largest mosques, known for its grand architecture, beautiful domes, and historical importance. It attracts visitors from across the country."
  },
  {
    title: "Bhopal Tribal Museum",
    description: "Bhopal Tribal Museum showcases the rich culture, traditions, art, and lifestyle of Madhya Pradesh's tribal communities through creative displays."
  },
  {
    title: "Ujjain Mahakaleshwar Temple",
    description: "Ujjain is a famous pilgrimage destination near Bhopal, known for Mahakaleshwar Jyotirlinga, Mahakal Lok, temples, and spiritual attractions."
  },
  {
    title: "Pachmarhi",
    description: "Pachmarhi is a beautiful hill station in Madhya Pradesh known for waterfalls, caves, viewpoints, forests, and peaceful natural surroundings. It is a popular destination for family vacations."
  },
  {
    title: "Jabalpur",
    description: "Jabalpur is famous for Marble Rocks, Dhuandhar Falls, Bhedaghat, and scenic landscapes. It is a popular destination for nature lovers and weekend travelers from Bhopal."
  }
],




"services": [
  {
    "name": "Mumbai to Bhopal Cab",
    "description": "Book Mumbai to Bhopal Cab for safe, comfortable, and reliable interstate travel with professional chauffeurs and well-maintained AC vehicles. Choose from Sedan, Ertiga, Innova, Innova Crysta, SUV, and premium cars for business trips, family journeys, airport transfers, and long-distance travel with flexible one way and round trip options."
  },
  {
    "name": "Mumbai to Bhopal Taxi",
    "description": "Choose Mumbai to Bhopal Taxi for convenient and comfortable road travel with experienced drivers and spacious vehicles. Enjoy affordable fares, doorstep pickup, clean AC cars, and reliable taxi services for personal, corporate, and family travel needs."
  },
  {
    "name": "Mumbai to Bhopal Cab Service",
    "description": "Book Mumbai to Bhopal Cab Service for dependable long-distance transportation with trained chauffeurs and premium vehicles. Our cab services provide comfortable travel solutions for family trips, corporate journeys, medical visits, and personal transportation requirements."
  },
  {
    "name": "Mumbai to Bhopal Taxi Service",
    "description": "Hire Mumbai to Bhopal Taxi Service for smooth interstate travel with professional drivers and well-maintained cars. Get reliable transportation with flexible booking options, comfortable seating, and affordable packages for your journey from Mumbai to Bhopal."
  },
  {
    "name": "Mumbai to Bhopal Cab Booking",
    "description": "Complete Mumbai to Bhopal Cab Booking with easy reservations, quick confirmation, and multiple vehicle choices. Select Sedan, SUV, Ertiga, Innova, or premium cars according to your group size and travel requirements."
  },
  {
    "name": "Mumbai to Bhopal Car Rental",
    "description": "Choose Mumbai to Bhopal Car Rental for chauffeur-driven vehicles designed for comfortable interstate travel. Enjoy spacious cars, experienced drivers, flexible schedules, and affordable rental packages for business, family, and personal trips."
  },
  {
    "name": "Mumbai to Bhopal Taxi Fare",
    "description": "Get Mumbai to Bhopal Taxi Fare details with transparent pricing and competitive travel packages. Enjoy comfortable cab services with no hidden charges, professional chauffeurs, and vehicle options suitable for individuals, families, and groups."
  },
  {
    "name": "Mumbai to Bhopal One Way Cab",
    "description": "Book Mumbai to Bhopal One Way Cab for convenient drop taxi service without return fare charges. Travel comfortably with experienced drivers, clean vehicles, and flexible pickup facilities for a hassle-free one-way journey."
  },
  {
    "name": "Mumbai to Bhopal Round Trip Taxi",
    "description": "Reserve Mumbai to Bhopal Round Trip Taxi for return travel with flexible schedules and comfortable vehicles. Ideal for family visits, business travel, sightseeing, and extended stays with reliable chauffeur-driven service."
  },
  {
    "name": "Mumbai to Bhopal Outstation Cab",
    "description": "Choose Mumbai to Bhopal Outstation Cab for safe and reliable interstate transportation. Enjoy premium vehicles, professional drivers, and comfortable travel options for long-distance journeys between Mumbai and Bhopal."
  },
  {
    "name": "Mumbai Airport to Bhopal Cab",
    "description": "Book Mumbai Airport to Bhopal Cab for convenient airport transfer and long-distance travel. Get timely pickup, luggage-friendly vehicles, experienced chauffeurs, and smooth transportation from Mumbai Airport to Bhopal."
  },
  {
    "name": "Mumbai to Bhopal Private Taxi",
    "description": "Hire Mumbai to Bhopal Private Taxi for personalized travel with a dedicated vehicle and professional chauffeur. Enjoy privacy, flexible routes, comfortable seating, and a peaceful journey for business or personal travel."
  },
  {
    "name": "Mumbai to Bhopal Innova Cab",
    "description": "Book Mumbai to Bhopal Innova Cab for spacious and comfortable travel with premium seating and extra luggage space. Perfect for families and groups looking for a reliable vehicle for long-distance journeys."
  },
  {
    "name": "Mumbai to Bhopal Innova Crysta Cab",
    "description": "Choose Mumbai to Bhopal Innova Crysta Cab for luxury and comfortable interstate travel. Experience premium interiors, smooth rides, professional chauffeurs, and enhanced comfort for family trips, corporate journeys, and group travel."
  },
  {
    "name": "Mumbai to Bhopal Ertiga Cab",
    "description": "Reserve Mumbai to Bhopal Ertiga Cab for affordable group transportation with spacious seating and comfortable interiors. Suitable for families, small groups, and travelers looking for economical long-distance cab service."
  },
  {
    "name": "Mumbai to Bhopal Sedan Cab",
    "description": "Book Mumbai to Bhopal Sedan Cab for economical and comfortable travel with professional drivers and clean AC vehicles. Ideal for couples, small families, business travelers, and passengers who prefer a smooth highway journey."
  },
  {
    "name": "Reliable Mumbai Bhopal Taxi Service",
    "description": "Choose Reliable Mumbai Bhopal Taxi Service for safe, comfortable, and affordable interstate travel with trained chauffeurs, clean vehicles, transparent pricing, and dependable customer support. Whether you need a business trip, family journey, airport transfer, or long-distance cab, enjoy a smooth travel experience from Mumbai to Bhopal."
  }
],
"tableData": [
  ["Mumbai to Bhopal Cab", "Mumbai to Bhopal Taxi"],
  ["Mumbai to Bhopal Cab Service", "Mumbai to Bhopal Taxi Service"],
  ["Mumbai to Bhopal Cab Booking", "Mumbai to Bhopal Car Rental"],
  ["Mumbai to Bhopal Taxi Fare", "Mumbai to Bhopal One Way Cab"],
  ["Mumbai to Bhopal Round Trip Taxi", "Mumbai to Bhopal Outstation Cab"],
  ["Mumbai Airport to Bhopal Cab", "Mumbai to Bhopal Private Taxi"],
  ["Mumbai to Bhopal Innova Cab", "Mumbai to Bhopal Innova Crysta Cab"],
  ["Mumbai to Bhopal Ertiga Cab", "Mumbai to Bhopal Sedan Cab"],
  ["Reliable Mumbai Bhopal Taxi Service", ""]
],




whychoose: [
  {
    WhyChooseheading: "Reliable Mumbai to Bhopal Cab Service",
    WhyChoosedescription: "Shreesha Travels offers comfortable Mumbai to Bhopal cab services for business trips, family travel, relocation, medical visits, and personal journeys. Travel conveniently with professional chauffeurs and well-maintained vehicles designed for long-distance routes."
  },
  {
    WhyChooseheading: "Comfortable Interstate Road Travel",
    WhyChoosedescription: "Enjoy a smooth road journey from Mumbai to Bhopal with spacious cars, flexible travel schedules, and personalized cab solutions that make long-distance travel comfortable and stress-free."
  },
  {
    WhyChooseheading: "Multiple Vehicle Choices for Every Need",
    WhyChoosedescription: "Choose from Sedan Cars, Swift Dzire, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and other vehicles based on passenger count, luggage, and comfort preferences."
  },
  {
    WhyChooseheading: "Suitable for Family, Corporate & Personal Trips",
    WhyChoosedescription: "Our Mumbai to Bhopal taxis are ideal for family visits, corporate travel, educational tours, medical journeys, business meetings, and customized Madhya Pradesh travel plans."
  },
  {
    WhyChooseheading: "One-Way & Round Trip Cab Booking Available",
    WhyChoosedescription: "Select a one-way cab for direct travel to Bhopal or choose a round-trip package with flexible return schedules and customized travel arrangements."
  },
  {
    WhyChooseheading: "Experienced Drivers for Long Highway Routes",
    WhyChoosedescription: "Our professional chauffeurs have experience handling interstate routes and ensure safe driving, timely pickups, and a comfortable journey throughout the Mumbai to Bhopal route."
  },
  {
    WhyChooseheading: "Well-Maintained Cars for Long Distance Journeys",
    WhyChoosedescription: "Each vehicle is regularly serviced, cleaned, air-conditioned, and inspected before departure to provide a reliable and pleasant travel experience."
  },
  {
    WhyChooseheading: "Book Mumbai to Bhopal Cab with Shreesha Travels",
    WhyChoosedescription: "Get transparent pricing, easy booking assistance, flexible travel options, and dependable chauffeur-driven cab services for your Mumbai to Bhopal journey."
  }
]

};

const faqData = [
  {
    question: "Can I book a Mumbai to Bhopal cab for one-way travel?",
    answer: "Yes, one-way cab services are available for passengers who need direct transportation from Mumbai to Bhopal."
  },
  {
    question: "Which vehicles are available for Mumbai to Bhopal cab booking?",
    answer: "We provide Sedan Cars, Swift Dzire, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and other comfortable vehicles."
  },
  {
    question: "Is Mumbai to Bhopal cab service suitable for families?",
    answer: "Yes, spacious vehicles with professional drivers make the journey comfortable for families travelling with luggage."
  },
  {
    question: "Can I book a round-trip taxi from Mumbai to Bhopal?",
    answer: "Yes, round-trip cab packages are available with flexible return dates and customized travel plans."
  },
  {
    question: "Do you provide cabs for business travel between Mumbai and Bhopal?",
    answer: "Yes, our services are suitable for corporate visits, official meetings, client travel, and business tours."
  },
  {
    question: "Can I customize the route during the Mumbai to Bhopal journey?",
    answer: "Yes, customized routes with planned stops and additional destinations can be arranged according to your requirements."
  },
  {
    question: "Are overnight travel options available for Mumbai to Bhopal?",
    answer: "Yes, overnight departures and long-distance travel arrangements can be planned based on your preferred schedule."
  },
  {
    question: "How is the Mumbai to Bhopal cab fare calculated?",
    answer: "The fare depends on vehicle type, travel distance, trip duration, route, driver charges, and additional travel requirements."
  },
  {
    question: "Can senior citizens travel comfortably by Mumbai to Bhopal taxi?",
    answer: "Yes, comfortable vehicles and experienced chauffeurs make long journeys convenient and safe for senior citizens."
  },
  {
    question: "How can I book Mumbai to Bhopal Cab with Shreesha Travels?",
    answer: "Share your pickup location, travel date, passenger details, preferred vehicle, and trip requirements to receive a customized quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Verma",
    feedback: "The Mumbai to Bhopal journey was smooth and comfortable. The driver was experienced, the vehicle was clean, and the entire trip was managed professionally.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Ritu Sharma",
    feedback: "We travelled with our family and had a great experience. The comfortable car and reliable service made the long-distance journey convenient and enjoyable.",
    rating: 5
  }
];





    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Bhopal Cab",
  "image": "https://www.shreeshatravels.com/assets/images/mumbai-to-bhopal-cab.webp",
  "description":
    "Book Mumbai to Bhopal Cab with Shreesha Tours & Travels for safe, comfortable, and affordable outstation taxi services. We provide one-way and round-trip cabs from Mumbai to Bhopal with Sedan, Ertiga, SUV, Innova, and Innova Crysta available 24x7 for business travel, family trips, city transfers, airport travel, and long-distance journeys across states.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/mumbai-to-bhopal-cab"
  }
};






    return (
        <div>
<Helmet>
  <title>Mumbai to Bhopal Cab | One Way & Round Trip Taxi | +91 8355835813</title>

  <meta
    name="description"
    content="Book Mumbai to Bhopal Cab with Shreesha Travels for reliable one-way and round-trip taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for comfortable long-distance travel, family trips, business journeys, and outstation routes with 24x7 booking."
  />

  <meta
    name="keywords"
    content="Mumbai to Bhopal Cab, Mumbai to Bhopal Taxi, Mumbai to Bhopal Cab Service, Mumbai to Bhopal Taxi Service, Mumbai to Bhopal Cab Booking, Mumbai to Bhopal Car Rental, Mumbai to Bhopal Taxi Fare, Mumbai to Bhopal One Way Cab, Mumbai to Bhopal Round Trip Taxi, Mumbai to Bhopal Outstation Cab, Mumbai Bhopal Taxi Service, Mumbai Bhopal Car Rental"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/66.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitobhopalcab;